import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog,MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-sig-test-modal',
  templateUrl: './sig-test-modal.component.html',
  styleUrls: ['./sig-test-modal.component.scss']
})
export class SigTestModalComponent implements OnInit {
  public type:string;
  constructor(
    private dialoge:MatDialog,

  ) { }

  ngOnInit(): void {
  }
  closeDialoge(){
    this.dialoge.closeAll();
  }
}
